import React from 'react'
import { LinearProgress } from '@mui/material'

function PageLoading() {
  return <LinearProgress />
}

export default PageLoading
